import { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { ArrowLeft, CaretLeft, BookOpen } from "@phosphor-icons/react";
import duasSections from "../../data/duasSections.json";
import PageTitle from "../../components/ui/PageTitle";
import { slugify } from "./utils";

type DuaItem = { title: string; header?: string; text?: string; text2?: string };
type DuaParent = { title: string; icon?: string; duas?: DuaItem[] };
type Section = { title: string; items: DuaParent[] };

export default function DuaReadListPage() {
  const { parentSlug = "" } = useParams();
  const navigate = useNavigate();

  const parent = useMemo(() => {
    for (const s of duasSections as Section[]) for (const it of s.items)
      if (slugify(it.title) === parentSlug) return it;
  }, [parentSlug]);

  const data = parent?.duas ?? [];

  return (
    <Container>
      <TopBar>
        <Back onClick={() => navigate(-1)} aria-label="رجوع">
          <ArrowLeft size={18} weight="bold" color="#fff" />
        </Back>
        <PageTitle center icon={<BookOpen size={24} color="var(--primary)" weight="duotone" />}>
          {parent?.title ?? "القائمة"}
        </PageTitle>
      </TopBar>

      <ListCard>
        {data.map((d, i) => (
          <Row
            key={i}
            onClick={() => navigate(`/mafatih/list/${parentSlug}/${slugify(d.title)}`)}
            dir="rtl"
          >
            <Badge>{i + 1}</Badge>
            <Title>{d.title}</Title>
            <CaretLeft size={22} color="var(--primary)" />
          </Row>
        ))}
      </ListCard>
    </Container>
  );
}

/* styles */
const Container = styled.div`
  padding: 24px 16px; max-width: 960px; margin: 0 auto;
`;
const TopBar = styled.div`
  display:flex; align-items:center; gap:12px; justify-content:center; position:relative;
`;
const Back = styled.button`
  position:absolute; inset-inline-start:0; top:0;
  width:40px; height:40px; border-radius:20px; border:none; cursor:pointer;
  background: linear-gradient(135deg, var(--primary), var(--border));
  display:grid; place-items:center; box-shadow: 0 6px 12px rgba(0,0,0,.15);
`;
const ListCard = styled.div`
  margin-top: 12px; background: var(--surface); border-radius: 16px; box-shadow: var(--shadow);
  padding: 8px;
`;
const Row = styled.button`
  width:100%; display:flex; align-items:center; gap:12px; border:0; cursor:pointer;
  background:transparent; color:var(--text);
  padding:12px; border-radius:12px; position:relative;
  &:hover{ background: var(--surface-2, rgba(0,0,0,.05)); }
`;
const Badge = styled.span`
  width:34px; height:34px; border-radius:17px; display:grid; place-items:center;
  background: linear-gradient(135deg, var(--border), var(--primary)); color:#0f172a; font-weight:700;
`;
const Title = styled.span`
  flex:1; text-align:center; font-size:1.05rem; font-weight:400; color:var(--text);
`;
